/**
 * Created by shem.mahluf on 06/09/2016.
 */
import C from  '../constants/app';
import * as  utils from '../utils/helpers';

// import { getAjaxRequest } from '../utils/helpers';
// import { shadeColor2 } from '../utils/helpers';
// import { linearGradient, hexToRgba } from '../utils/helpers';

export function getSSPPermissions() {
    let url = 'api/v1/sc/permissions';
    return utils.dispatchAjaxResponseWithCharger(url, C.GET_SSP_PERMISSIONS_LIST);
}

export function getActiveTheme(preview, themeId) {
    function setTheme(data, dispatch, isPreview) {
        const Theme = data;

        const darkenPercentage = -0.25;
        const lightenPercentage = 0.5;
        const shadeOpacityPercentage = 0.5;

        const DarkenTheme = {
            brandColorDarken: utils.shadeColor2(Theme.brandColor, darkenPercentage),
            brandContrastDarken: utils.shadeColor2(Theme.brandContrast, darkenPercentage),
            headerBackgroundDarken: utils.shadeColor2(Theme.headerBackground, darkenPercentage),
            menuTextDarken: utils.shadeColor2(Theme.menuText, darkenPercentage),
            buttonBackgroundDarken: utils.shadeColor2(Theme.buttonBackground, darkenPercentage),
            chatbotBorderDarken: utils.shadeColor2(Theme.chatbotBorder, darkenPercentage)
        };

        const LightenTheme = {
            brandColorLighten: utils.shadeColor2(Theme.brandColor, lightenPercentage),
            buttonBackgroundLighten: utils.shadeColor2(Theme.buttonBackground, lightenPercentage),
            buttonContentLighten: utils.shadeColor2(Theme.buttonContent, lightenPercentage),
            hoverColorLighten: utils.shadeColor2(Theme.hoverColor, lightenPercentage),
            textColorLighten: utils.shadeColor2(Theme.textColor, lightenPercentage)

        };

        const linearGradientTheme = {
            linearGradient: utils.linearGradient(Theme.pageBackground, 'bottom'),
            linearGradientRight: utils.linearGradient(Theme.pageBackground, 'right'),
            linearGradientRightHover: utils.linearGradient(Theme.hoverColor, 'right'),
            linearGradientLeft: utils.linearGradient(Theme.pageBackground, 'left'),
            linearGradientLeftHover: utils.linearGradient(Theme.hoverColor, 'left')
        };

        const boxShadowTheme = {
            boxShadowRGBA: utils.hexToRgba(Theme.brandColor, shadeOpacityPercentage)
        };

        const btnBackgroundDarkenShadowTheme={
            btnBackgroundDarkenShadowRGBA: utils.hexToRgba(Theme.brandColor, shadeOpacityPercentage)
        };
        const hasPreview = {hasPreview: !!isPreview};
        dispatch({
            type: C.GET_THEME,
            payload: Object.assign(Theme, DarkenTheme, LightenTheme, linearGradientTheme, boxShadowTheme, btnBackgroundDarkenShadowTheme, hasPreview)
        });
    }

    return (dispatch) => {
        if (!themeId && preview === '1' && localStorage.theme) {
            let theme = JSON.parse(localStorage.theme);
            if (theme) {
                setTheme(theme, dispatch, true);
                window.addEventListener('storage', (event) => {
                    if (event.key === 'theme') {
                        // fix for IE11: check that values had changed
                        // see https://stackoverflow.com/q/20565508/1723752
                        if (event.oldValue !== event.newValue) {
                            theme = JSON.parse(localStorage.theme);
                            if (theme) {
                                setTheme(theme, dispatch, true);
                            }
                        }
                    }
                }, false);
                return;
            }
        }
        dispatch(setFetchingCount(true));
        let url = 'api/v1/sc/theme';
        if (themeId) {
            url += `/${themeId}`;
        }
        utils.axiosInstance.get(url)
            .then((response) => {
                setTheme(response.data, dispatch, themeId);
                return null;
            })
            .finally(() => {
                dispatch(setFetchingCount(false));
            })
        ;
    }

}
export function setFetchingCount(isFetching){
    return {
        type: C.SET_IS_FETCHING,
        payload: isFetching
    };
}
export function closeCharger(){
    return {
        type: C.CLOSE_CHARGER
    };
}

export function getSSPPreferences() {
    let url = 'api/v1/sc/preferences';
    return utils.dispatchAjaxResponseWithCharger(url, C.GET_SSP_PREFERENCES);
}

export async function getLoginUrl(){
    let url = 'api/v1/sc/loginUrl';
    
    let promis = utils.axiosInstance.get(url);
    return promis;
}


// WEBPACK FOOTER //
// ./actions/app.js